import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TextFieldModule } from '@angular/cdk/text-field';
import { PlatformModule } from '@angular/cdk/platform';

import { APipesModule } from '@acaprojects/ngx-pipes';
import { AOverlayModule } from '@acaprojects/ngx-overlays';
import { ADynamicFormsModule } from '@acaprojects/ngx-dynamic-forms';
import { ACustomEventsModule } from '@acaprojects/ngx-custom-events';

import { BaseComponent } from './base.component';
import { IconComponent } from './components/icon/icon.component';
import { HeaderBarComponent } from './components/header-bar/header-bar.component';
import { ResizeWrapperComponent } from './components/resize-wrapper/resize-wrapper.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { PexipWindowComponent } from './components/pexip/pexip.component';

// custom pipes
import { ShowTimePipe, FromNowPipe } from './pipes/date.pipe';

import { DirectivesModule } from './directives/directives.module';

const COMPONENTS: Type<any>[] = [
    BaseComponent,
    HeaderBarComponent,
    ResizeWrapperComponent,
    TimePickerComponent,
    PexipWindowComponent,
    IconComponent,
];

const MATERIAL_MODULES: any[] = [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatTooltipModule,
    TextFieldModule,
    PlatformModule
];

const PIPES: Type<any>[] = [ShowTimePipe, FromNowPipe];

const ENTRY_COMPONENT: Type<any>[] = [];

@NgModule({
    declarations: [
        ...COMPONENTS,
        ...PIPES,
        // ...ENTRY_COMPONENT,
    ],
    imports: [
        CommonModule,
        APipesModule,
        AOverlayModule,
        FormsModule,
        ReactiveFormsModule,
        ACustomEventsModule,
        ADynamicFormsModule,
        DirectivesModule,
        ...MATERIAL_MODULES,
    ],
    exports: [
        APipesModule,
        AOverlayModule,
        FormsModule,
        ReactiveFormsModule,
        ACustomEventsModule,
        ADynamicFormsModule,
        DirectivesModule,
        ...COMPONENTS,
        ...PIPES,
        ...MATERIAL_MODULES,
        // ...ENTRY_COMPONENT
    ],
    entryComponents: [
        // ...ENTRY_COMPONENT
    ],
})
export class SharedContentModule {}
